var cineweb = cineweb || {};
cineweb.infiniteScroll = cineweb.infiniteScroll || {};
cineweb.infiniteScroll.resize = function (container, html) {
    container.append(jQuery(html).find('ul#search-items').html());
    var resizePoster = function () {
        jQuery('.link-poster-media').each(function () {
            jQuery(this).height(jQuery(this).width() * 1.33);
        });
    };

    resizePoster();

    jQuery(window).resize(function () {
        resizePoster();
    });
};
cineweb.infiniteScroll.articleResize =  function () {
    jQuery('.link-poster-media-article').each(function () {
        jQuery(this).height(jQuery(this).width() / 1.6);
    });
};
cineweb.infiniteScroll.fetchNextPage = function (e) {
    e.preventDefault();

    var url = jQuery(this).attr('href'),
    callback = jQuery(this).data('callback'),
    trigger_container = jQuery(this).parent(),
    previous_container = trigger_container.parent();
    trigger_container.html('<img src="/bundles/cineweb/images/icons/preloder.gif" alt="" class="preloder-icon">');

    jQuery.get(url, function (data) {
        trigger_container.remove();
        if (callback === undefined) {
            previous_container.after(data);
            cineweb.infiniteScroll.articleResize();
        } else {
            window['cineweb']['infiniteScroll'][callback](previous_container, data);
        }
    });
}

// Infinite scroll blocks
// Used by edito / feed
jQuery(document).ready(function() {
    jQuery('#main-container').on(
        'click',
        '.infinite-scroll',
        cineweb.infiniteScroll.fetchNextPage
    );
});

